import { useTranslation } from "react-i18next";

const AudioPermissionCard = ({
    showAudioPermissionCard,
    onCloseAudioPermissionCard,
    denied = false,
}) => {
    const { t } = useTranslation();

    return (
        showAudioPermissionCard && (
            <div className="fixed inset-0 flex items-center justify-center z-50 px-3 py-2">
                {/* Overlay to gray out the rest of the page */}
                <div className="absolute inset-0 bg-black opacity-50"></div>
                <div className="p-3 relative rounded-md bg-white h-auto w-[28rem] max-w-full max-h-[calc(100vh-1rem)] overflow-y-auto">
                    {/* Close button in top-right */}
                    <button
                        className="rounded-md border border-border absolute top-4 right-4 p-1 text-gray-600 hover:bg-gray-100"
                        onClick={() => onCloseAudioPermissionCard(false)}
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                            className="size-5"
                        >
                            <path d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z" />
                        </svg>
                    </button>
                    {/* Title top left */}
                    <div className="flex flex-row gap-2 items-center h-10">
                        <div className="bg-black rounded-full h-10 w-10 flex items-center justify-center">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 16 16"
                                fill="white"
                                className="size-5"
                            >
                                <path d="M8 1a2 2 0 0 0-2 2v4a2 2 0 1 0 4 0V3a2 2 0 0 0-2-2Z" />
                                <path d="M4.5 7A.75.75 0 0 0 3 7a5.001 5.001 0 0 0 4.25 4.944V13.5h-1.5a.75.75 0 0 0 0 1.5h4.5a.75.75 0 0 0 0-1.5h-1.5v-1.556A5.001 5.001 0 0 0 13 7a.75.75 0 0 0-1.5 0 3.5 3.5 0 1 1-7 0Z" />
                            </svg>
                        </div>
                        <div>
                            <h3 className="font-semibold text-lg">
                                {t("permissions.microphone.header-enable")}
                            </h3>
                            <p className="text-xs text-gray-700">
                                {t("permissions.microphone.subtitle-enable")}
                            </p>
                        </div>
                    </div>
                    <div className="mt-4 flex flex-col gap-3">
                        {/* Reason */}
                        <div className="flex gap-2 items-center">
                            <div className="border border-border rounded-full min-h-7 min-w-7 flex items-center justify-center">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 16 16"
                                    fill="currentColor"
                                    className="size-4"
                                >
                                    <path d="M7.557 2.066A.75.75 0 0 1 8 2.75v10.5a.75.75 0 0 1-1.248.56L3.59 11H2a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h1.59l3.162-2.81a.75.75 0 0 1 .805-.124ZM12.95 3.05a.75.75 0 1 0-1.06 1.06 5.5 5.5 0 0 1 0 7.78.75.75 0 1 0 1.06 1.06 7 7 0 0 0 0-9.9Z" />
                                    <path d="M10.828 5.172a.75.75 0 1 0-1.06 1.06 2.5 2.5 0 0 1 0 3.536.75.75 0 1 0 1.06 1.06 4 4 0 0 0 0-5.656Z" />
                                </svg>
                            </div>
                            <div className="max-w-xs">
                                <h4 className="text-sm font-medium">
                                    {t("permissions.microphone.use-case-header")}
                                </h4>
                                <p className="text-xs text-gray-700">
                                    {t("permissions.microphone.use-case-subtitle")}
                                </p>
                            </div>
                        </div>
                        {/* Privacy */}
                        <div className="flex gap-2 items-center">
                            <div className="border border-border rounded-full min-h-7 min-w-7 flex items-center justify-center">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 16 16"
                                    fill="currentColor"
                                    className="size-4"
                                >
                                    <path
                                        fillRule="evenodd"
                                        d="M8.5 1.709a.75.75 0 0 0-1 0 8.963 8.963 0 0 1-4.84 2.217.75.75 0 0 0-.654.72 10.499 10.499 0 0 0 5.647 9.672.75.75 0 0 0 .694-.001 10.499 10.499 0 0 0 5.647-9.672.75.75 0 0 0-.654-.719A8.963 8.963 0 0 1 8.5 1.71Zm2.34 5.504a.75.75 0 0 0-1.18-.926L7.394 9.17l-1.156-.99a.75.75 0 1 0-.976 1.138l1.75 1.5a.75.75 0 0 0 1.078-.106l2.75-3.5Z"
                                        clipRule="evenodd"
                                    />
                                </svg>
                            </div>
                            <div>
                                <h4 className="text-sm font-medium">
                                    {t("permissions.microphone.privacy-header")}
                                </h4>
                                <p className="text-xs text-gray-700">
                                    {t("permissions.microphone.privacy-subtitle")}{" "}
                                    <a
                                        className="text-primary"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        href="https://learn.microsoft.com/en-us/azure/ai-foundry/responsible-ai/speech-service/speech-to-text/data-privacy-security"
                                    >
                                        {t("learn-more")}
                                    </a>
                                </p>
                            </div>
                        </div>
                    </div>
                    {!denied && (
                        <div className="mt-4 bg-yellow-100 rounded-md h-auto pb-1 border border-yellow-300">
                            <div className="flex items-start my-2 mx-3 gap-2">
                                <div className="min-w-3 w-3 min-h-3 h-3 rounded-full bg-yellow-400 mt-1"></div>
                                <div>
                                    <h4 className="font-medium text-sm text-yellow-700">
                                        {t(
                                            "permissions.microphone.browser-permission-warning-header",
                                        )}
                                    </h4>
                                    <p className="text-xs text-yellow-600">
                                        {t(
                                            "permissions.microphone.browser-permission-warning-subtitle",
                                        )}
                                    </p>
                                </div>
                            </div>
                        </div>
                    )}
                    {denied && (
                        <div className="mt-4 bg-red-100 rounded-md h-auto pb-1 border border-red-300">
                            <div className="flex items-start my-2 mx-3 gap-2">
                                <div className="min-w-3 w-3 min-h-3 h-3 rounded-full bg-red-400 mt-1"></div>
                                <div>
                                    <h4 className="font-medium text-sm text-red-700">
                                        {t(
                                            "permissions.microphone.browser-permission-warning-header",
                                        )}
                                    </h4>
                                    <p className="text-xs text-red-600">
                                        {t(
                                            "permissions.microphone.browser-permission-error-subtitle",
                                        )}
                                    </p>
                                </div>
                            </div>
                        </div>
                    )}
                    <div className="flex gap-3 mt-3 ">
                        <button
                            className="rounded-md bg-primary hover:bg-purple-500 w-full h-10"
                            onClick={() => onCloseAudioPermissionCard(true)}
                        >
                            <p className="text-white font-medium text-sm">
                                {t("permissions.microphone.allow")}
                            </p>
                        </button>
                        <button
                            className="rounded-md w-20"
                            onClick={() => onCloseAudioPermissionCard(false)}
                        >
                            <p className="text-gray-700 text-xs">
                                {t("permissions.microphone.skip")}
                            </p>
                        </button>
                    </div>
                </div>
            </div>
        )
    );
};

export default AudioPermissionCard;
